// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/DataQueues/EventDialogServiceTimeSidebar.js

import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact';
import { Row, Col } from 'react-bootstrap';
import '../../css/EventDialogServiceTimeSidebar.scss';
import PaymentDetails from './EventDialogServiceTimeSidebar/PaymentDetails';
import InputSwitchWrapper from './EventDialogServiceTimeSidebar/InputSwitchWrapper';
import PaymentMethodContainer from './EventDialogServiceTimeSidebar/PaymentMethodContainer';
import PaymentLabels from './EventDialogServiceTimeSidebar/PaymentLabels';
import SubmitButton from './EventDialogServiceTimeSidebar/SubmitButton';
import usePaymentLogic from './EventDialogServiceTimeSidebar/usePaymentLogic';

const EventDialogServiceTimeSidebar = ({
  isSidebarVisible,
  onHide,
  toggleTopSidebarVisible,
  selectedDate,
  priceID,
  fetchReserveServiceTimes,
  cumulativePrice,
  handleSubmit,
  hideServiceTypeSidebar,
  onHideDialog,
  refreshParentData,
  clearCumulativePrice,
}) => {
  const [reserveServiceTimes, setReserveServiceTimes] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const {
    paymentMethodGroup1,
    paymentMethodGroup2,
    paymentPercentage,
    paymentAmount,
    loading,
    paymentDetails,
    translations,
    topSidebarVisible,
    sidebarContentRef,
    setPaymentMethodGroup1,
    setTopSidebarVisible,
    setPaymentAmount,
    handlePaymentPercentageChange,
    handlePaymentMethodChangeGroup1,
    handlePaymentMethodChangeGroup2,
    handlePaymentAmountChange,
    handleInputFocus,
    handleInputBlur,
    handleSubmitClick,
    simulateAvailableTimes, // Now from usePaymentLogic
  } = usePaymentLogic({
    cumulativePrice,
    handleSubmit,
    onHide,
    hideServiceTypeSidebar,
    onHideDialog,
    refreshParentData,
  });

  useEffect(() => {
    if (isSidebarVisible && shouldFetch) {
      setPaymentMethodGroup1('payCash');
      setIsRefreshing(true);
      fetchReserveServiceTimes(selectedDate, priceID, (times) => {
        setReserveServiceTimes(simulateAvailableTimes(times));
        setIsRefreshing(false);
      });
      setShouldFetch(false);
      setTopSidebarVisible(true);
    }
  }, [isSidebarVisible, selectedDate, priceID, fetchReserveServiceTimes, shouldFetch, setPaymentMethodGroup1, setTopSidebarVisible]);

  return (
    <Sidebar
      visible={isSidebarVisible}
      position="bottom"
      onHide={() => {
        toggleTopSidebarVisible();
        setTopSidebarVisible(false); // Corrected typo
      }}
      className="custom-bottom-sidebar"
    >
      <div className="sidebar-content" ref={sidebarContentRef}>
        <Row>
          <Col xs={4} className="cumulative-total-container text-center">
            <Row>
              <Col xs={3} className="cumulative-total-container text-center">
                <PaymentLabels />
              </Col>
              <Col xs={4} className="payment-method-container payment-InputSwitch">
                <InputSwitchWrapper paymentMethodGroup1={paymentMethodGroup1} handlePaymentMethodChangeGroup1={handlePaymentMethodChangeGroup1} />
              </Col>
              <Col xs={4} className="credit-card-input-container">
                <PaymentDetails paymentMethodGroup1={paymentMethodGroup1} paymentDetails={paymentDetails} />
              </Col>
            </Row>
          </Col>
          <Col xs={4} className="payment-method-container">
            <PaymentMethodContainer
              paymentMethodGroup2={paymentMethodGroup2}
              handlePaymentMethodChangeGroup2={handlePaymentMethodChangeGroup2}
              paymentAmount={paymentAmount}
              handlePaymentAmountChange={handlePaymentAmountChange}
              handleInputFocus={handleInputFocus}
              handleInputBlur={handleInputBlur}
              paymentPercentage={paymentPercentage}
              handlePaymentPercentageChange={handlePaymentPercentageChange}
            />
          </Col>
          <Col xs={4}>
            <SubmitButton
              loading={loading}
              handleSubmitClick={() => handleSubmitClick("THB", setShouldFetch)}
              cumulativePrice={cumulativePrice}
              translations={translations}
            />
          </Col>
        </Row>
      </div>
    </Sidebar>
  );
};

export default EventDialogServiceTimeSidebar; 